import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { compose, pure } from '../../../../../src/web/utils/react';

const propTypes = {
  type: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    errors: PropTypes.string,
  }),
};

const defaultProps = {
  type: undefined,
  meta: undefined,
};

const Textarea = ({
  input,
  meta,
  ...props
}) => (
  <Form.Control
    as="textarea"
    {...props}
    {...input}
  />
);

Textarea.propTypes = propTypes;

Textarea.defaultProps = defaultProps;

export default compose(
  pure(),
)(Textarea);
